
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Link, Image } from '@ta-interaktiv/contentbricks'


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>
  Bei der Tröpfcheninfektion redet man von grossen Tropfen, die nicht
  lungengängig sind: 10, 50 oder 100 Mikrometer gross. Spucketröpfchen, die etwa
  beim Husten und bei feuchter Aussprache entstehen, sind am oberen Ende dieser
  Tropfengrössen. Wenn Tropfen so gross sind, landen sie relativ schnell auf dem
  Boden, dann reichen 1,5 oder 2 Meter Abstand aus. Eine Ansteckung geschieht
  nur über die direkte Abgabe und Aufnahme solcher Tropfen. Lungengängige
  Teilchen – Aerosole – fangen hingegen bei fünf Mikrometern und kleiner an und
  bleiben teilweise lange in der Luft. Schon bei fünf Mikrometern reicht der
  Sicherheitsabstand nicht, sie werden weitertransportiert und verteilen sich im
  Raum, und andere Menschen können sie einatmen und sich darüber infizieren.
    </p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;